import React from 'react';

import Highlight from '@components/FeedItems/Highlight';
import { briefing_feed_path } from '@routes';

interface HeadlineProps {
  headline: string;
  dek?: string;
}

const Headline = ({ headline, dek }: HeadlineProps) => (
  <header className="ttr-headline">
    <Highlight
      highlight="Briefing"
      customPath={briefing_feed_path()}
      className="!text-caption-md"
    />
    <h1 className="text-grayscale-black mb-0 mt-8 max-w-[884px] text-pretty font-suisse-works text-headline-md">
      {headline}
    </h1>
    {dek && <div className="mt-8 max-w-[884px] font-suisse-neue sm:text-subheadline-sm">{dek}</div>}
  </header>
);

export default Headline;
